// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jzon from "rescript-jzon/lib/es6/src/Jzon.res.js";
import * as LumiJzon from "lumi-rescript/lib/es6/src/LumiJzon.res.js";
import * as LumiReact from "lumi-rescript/lib/es6/src/LumiReact.res.js";
import * as FontAwesome$Web from "lumi-web/lib/es6/src/FontAwesome.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as RightAngle$LumiDocuments from "./Types/RightAngle.res.js";

let options = [
  "Fixed",
  "SunElevation"
];

let jsonCodec = LumiJzon.anySumAsString(options, undefined);

let BrightnessMode = {
  options: options,
  jsonCodec: jsonCodec
};

let jsonCodec$1 = Jzon.object4(param => [
  param.mode,
  param.fixed,
  param.day,
  param.night
], param => ({
  TAG: "Ok",
  _0: {
    mode: param[0],
    fixed: param[1],
    day: param[2],
    night: param[3]
  }
}), Jzon.field("mode", jsonCodec), Jzon.field("fixed", Jzon.int), Jzon.field("day", Jzon.int), Jzon.field("night", Jzon.int));

let Brightness = {
  jsonCodec: jsonCodec$1
};

import '../../../src/css/brightness-view.scss'
;

function SignSettings$BrightnessView(props) {
  let brightness = props.brightness;
  let config = props.config;
  let warning = [
    "triangle-exclamation",
    "has-text-warning"
  ];
  let match = config.mode;
  let mbIcon;
  if (match === "Fixed") {
    mbIcon = config.fixed === brightness ? undefined : warning;
  } else {
    let isDay = config.day === brightness;
    let isNight = config.night === brightness;
    mbIcon = isDay && !isNight ? [
        "sun",
        "day"
      ] : (
        !isDay && isNight ? [
            "moon",
            "night"
          ] : warning
      );
  }
  return JsxRuntime.jsxs("span", {
    children: [
      LumiReact.renderOption(undefined, mbIcon, param => JsxRuntime.jsx(FontAwesome$Web.Solid.make, {
        name: param[0],
        className: param[1]
      })),
      JsxRuntime.jsx("span", {
        children: brightness.toString() + `%`,
        className: "ml-1"
      })
    ]
  });
}

let BrightnessView = {
  make: SignSettings$BrightnessView
};

let jsonCodec$2 = Jzon.object5(param => [
  param.frameRate,
  param.colorDepth,
  param.panelBrightness,
  param.backlightBrightness,
  param.smallestSubFrameExposure
], param => ({
  TAG: "Ok",
  _0: {
    frameRate: param[0],
    colorDepth: param[1],
    panelBrightness: param[2],
    backlightBrightness: param[3],
    smallestSubFrameExposure: param[4]
  }
}), Jzon.field("frameRate", Jzon.nullable(Jzon.int)), Jzon.field("colorDepth", Jzon.int), Jzon.field("panelBrightness", jsonCodec$1), Jzon.field("backlightBrightness", jsonCodec$1), Jzon.field("smallestSubFrameExposure", Jzon.int));

let ScreenSettings = {
  jsonCodec: jsonCodec$2
};

let jsonCodec$3 = Jzon.object4(param => [
  param.name,
  param.x,
  param.y,
  param.rotation
], param => ({
  TAG: "Ok",
  _0: {
    name: param[0],
    x: param[1],
    y: param[2],
    rotation: param[3]
  }
}), Jzon.defaultTo(Jzon.field("name", Jzon.string), ""), Jzon.field("x", Jzon.int), Jzon.field("y", Jzon.int), Jzon.field("rotate", RightAngle$LumiDocuments.RightAngle.jsonCodec));

let Panel = {
  jsonCodec: jsonCodec$3
};

function panelSize(param) {
  switch (param.panelType) {
    case "P2" :
    case "P2-bgr" :
    case "P2_Neude" :
      return [
        128,
        64
      ];
    case "P3" :
    case "P4-bgr" :
    case "P4-bgr-slow" :
    case "P4-rgb" :
    case "P4-rgb-JXS-P4-2018-C" :
    case "P5" :
    case "P5-longcable" :
    case "P5-outdoor" :
      return [
        64,
        32
      ];
    case "P5-sawed-in-half" :
    case "P5-sawed-in-half-bgr" :
    case "P5-square" :
      return [
        32,
        32
      ];
    case "P8" :
      return [
        32,
        16
      ];
    default:
      return;
  }
}

let jsonCodec$4 = Jzon.object3(param => [
  param.panelType,
  param.screenSettings,
  param.panels
], param => ({
  TAG: "Ok",
  _0: {
    panelType: param[0],
    screenSettings: param[1],
    panels: param[2]
  }
}), Jzon.field("panelType", Jzon.string), Jzon.field("screenSettings", jsonCodec$2), Jzon.field("panels", LumiJzon.mapString(Jzon.array(jsonCodec$3))));

let SignSettings = {
  panelSize: panelSize,
  jsonCodec: jsonCodec$4
};

export {
  BrightnessMode,
  Brightness,
  BrightnessView,
  ScreenSettings,
  Panel,
  SignSettings,
}
/* jsonCodec Not a pure module */
